import { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { Information } from '@carbon/react/icons';
import cx from 'clsx';

import { TIER_LABEL } from 'models/tier';
import styles from 'theme/components/project-tier.module.scss';

export const ProjectTierTooltip = () => {
  const [id] = useState(() => `tooltip-${Date.now()}`);

  return (
    <>
      <button
        data-tooltip-id={id}
        data-tooltip-place="bottom"
        data-tooltip-position-strategy="fixed"
        className={styles.tooltip}
        type="button"
      >
        <Information />
      </button>
      <Tooltip id={id}>
        <p className={styles['tooltip-wrapper']}>
          <strong>Tier 1 - Large Projects</strong> <br />
          Attending population >500 <br />
          <strong>Tier 2 - Medium Projects</strong> <br />
          Attending population 50-500 <br />
          <strong>Tier 3 - Limited Projects</strong> <br />
          Attending population {'<'}50 <br />
        </p>
      </Tooltip>
    </>
  );
};

const ProjectTier = ({ tier, isValid = true, withTooltip = false, inline = false, size = 'sm' }) => {
  const content = (
    <>
      <span
        className={cx(
          styles.badge,
          isValid && styles[`badge--valid-${size}`],
          !isValid && styles['badge--invalid'],
          !isValid && styles[`badge--invalid-${size}`],
          inline && styles['badge--inline']
        )}
      >
        {TIER_LABEL[tier]}
      </span>
      {withTooltip && <ProjectTierTooltip />}
    </>
  );

  return inline ? (
    <span className={styles.wrapper}>
      &#xfeff;
      <span className={styles['content-inline']}>{content}</span>
    </span>
  ) : (
    <div>{content}</div>
  );
};

export default ProjectTier;
